var map = {
	"./Pier_1.png": 1317
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1316;


//////////////////
// WEBPACK FOOTER
// ./src/assets/outskirts/pier ^\.\/Pier_.*\.png$
// module id = 1316
// module chunks = 3